export default "__VITE_ASSET__51dae072__"